import parse from 'qs/lib/parse';
import md5 from './md5';
import compareVersions from './version';

const location = window.location;

let sensorsDataInstance = window.sensorsDataAnalytic201505;

const STATS_URL = 'https://lc.zt.changba.com/collectH5';
const SENSORS_DATA_MIN_VERSION = '1.21.10';
const SENSORS_DATA_MAX_VERSION = '1.22.7';

// -----------------------------------

const stats = window.cbStats;
const siteId = stats.siteId;

const OPERATION_PV = 'pv';
const OPERATION_ACTION = 'action';
const OPERATION_SUCCESS = 'success';
const OPERATION_FAILURE = 'failure';

const MODE_DEFAULT = 'default';

// 页面 PV 统计用的 button id
const DEFAULT_PV_IDENTIFIER = 'show_page_H5';

// 解析 URL 参数
const urlParams = {
  ...parse(location.search?.replace(/^\?/, '')),
  ...parse(location.hash?.replace(/.*\?/, ''))
};

let changbaVersion = '';
let marsVersion = '';
let urlSource = '';

const userAgent = window.navigator?.userAgent ?? '';

// ---------------------------------------------------------

const getPageId = () => stats.default.pageId || document.title;

// 获取 URL 来源参数
const getUrlSource = () => {
  return urlParams.refsrc
    || urlParams.source
    || urlParams.resadd
    || urlParams.from
    || urlParams.cbshare
    || '';
};

// 删除对象中的空值
const removeEmptyValueForObject = (obj) => {
  const result = {};

  for (const prop in obj) {
    if (obj[prop] !== undefined && obj[prop] !== null && obj[prop] !== '') {
      result[prop] = obj[prop];
    }
  }

  return result;
};

const getChangbaVersion = () => {
  const match = userAgent.match(/\s+changba\/([0-9.]+)/i);

  return match ? match[1] : '';
};

const getMarsVersion = () => {
  const match = userAgent.match(/\s+easylive\/([0-9.]+)/i);

  return match ? match[1] : '';
};

const send = (params = {}, loadCallback) => {
  let name = params.cbs_attr_button_id;

  if (!/^[a-z_][0-9a-z_$]+$/i.test(name)) {
    name = `cbs_name_${md5(name).substr(6, 7)}`;
  }

  // 直接调用神策的方法
  sensorsDataInstance?.track(name, params, loadCallback);
};

// ---------------------------------------

// 获取唱吧客户端版本号
changbaVersion = getChangbaVersion();
// 获取火星客户端版本号
marsVersion = getMarsVersion();
// 获取 URL 来源参数
urlSource = getUrlSource();

const operation = (op, buttonId, params, loadCallback) => {
  if (typeof params === 'function') {
    loadCallback = params;
    params = {};
  }

  if (!buttonId) {
    return false;
  }

  const extra = removeEmptyValueForObject({
    ...stats.default.extra
  });

  if (extra.refsrc) {
    extra.enter_source = extra.refsrc;
  }

  delete params.mode;
  delete extra.refsrc;

  const sendParams = {
    cbs_attr_page_id: getPageId(),
    cbs_attr_button_id: buttonId,
    cbs_attr_op: op,
    cbs_attr_op_mode: params.mode || MODE_DEFAULT,
    ...extra,
    ...params
  };

  if (siteId) {
    sendParams.cbs_attr_site_id = siteId;
  }

  send(sendParams, loadCallback);
};

stats.pv = (buttonId = DEFAULT_PV_IDENTIFIER, loadCallback) => {
  if (typeof buttonId === 'function') {
    loadCallback = buttonId;
    buttonId = DEFAULT_PV_IDENTIFIER;
  }

  operation(OPERATION_PV, buttonId, { mode: MODE_DEFAULT }, loadCallback);
};

stats.action = (buttonId, params = {}, loadCallback) => {
  operation(OPERATION_ACTION, buttonId, params, loadCallback);
};

stats.success = (buttonId, params = {}, loadCallback) => {
  operation(OPERATION_SUCCESS, buttonId, params, loadCallback);
};

stats.failure = (buttonId, params = {}, loadCallback) => {
  operation(OPERATION_FAILURE, buttonId, params, loadCallback);
};

// ---------------------------------------

const init = () => {
  if (!sensorsDataInstance) {
    return;
  }

  // 初始化
  sensorsDataInstance.init({
    server_url: STATS_URL,
    is_track_single_page: false,
    use_client_time: true,
    send_type: 'beacon',
    show_log: false,
    ...stats.default.sensorsData
  });

  // 初始化后才能拿到版本号，所以只能放到这里判断
  if (compareVersions(sensorsDataInstance?.lib_version, '<', SENSORS_DATA_MIN_VERSION) || compareVersions(sensorsDataInstance?.lib_version, '>', SENSORS_DATA_MAX_VERSION)) {
    sensorsDataInstance = null;
    throw `Sensors Data SDK 版本不支持，当前最低支持 ${SENSORS_DATA_MIN_VERSION} 版，最高支持 ${SENSORS_DATA_MAX_VERSION} 版。`;
  }

  if (urlParams.curuserid) {
    sensorsDataInstance.login(urlParams.curuserid);
  }

  const registerPage = {
    platform_type: 'javascript',
    data_version: 1,
    cbs_attr_changba_ver: changbaVersion,
    cbs_attr_mars_ver: marsVersion
  };

  if (stats.default?.extra?.refsrc) {
    registerPage.enter_source = stats.default.extra.refsrc;
  }

  if (urlSource) {
    registerPage.enter_source = urlSource;
  }

  sensorsDataInstance.registerPage(registerPage);

  stats.queue.forEach((value) => {
    let item = { ...value };
    const type = item.type;
    const button = item.button;

    item = { ...item.extra };

    delete item.type;
    delete item.button;
    delete item.extra;

    switch (type) {
      case 'page':
        stats.pv(DEFAULT_PV_IDENTIFIER);
        break;

      case 'pv':
        stats.pv(button || DEFAULT_PV_IDENTIFIER);
        break;

      default:
      case 'action':
        stats.action(button, item);
        break;

      case 'success':
        stats.success(button, item);
        break;

      case 'failure':
        stats.failure(button, item);
        break;
    }
  });
}

init();
